
const About = () => {
  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/3af1b54b94c30108b38b307b1e91af33.jpg"
                alt="Insurance consultation"
                className="w-full h-[400px] object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -right-8 bg-[#2196F3] text-white p-6 rounded-xl shadow-lg hidden md:block">
              <div className="text-4xl font-bold">15+</div>
              <div className="text-white/90">Years of Experience</div>
            </div>
          </div>

          <div>
            <span className="text-[#2196F3] font-semibold text-sm uppercase tracking-wider">About Us</span>
            <h3 className="text-3xl md:text-4xl font-bold text-[#0A2647] mt-3 mb-6">
              Your Trusted Partner for Private Health Insurance in Austin
            </h3>
            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              At InsuranceServicesTX, we understand that navigating the world of health insurance 
              can be overwhelming. That's why we're here to help. Our team of experienced professionals 
              is dedicated to finding the perfect coverage for you, your family, or your business.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              Based in Austin, Texas, we specialize in private health insurance solutions that 
              provide comprehensive coverage at competitive rates. We take the time to understand 
              your unique needs and guide you through every step of the process.
            </p>

            <div className="grid sm:grid-cols-2 gap-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#2196F3]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-heart-line text-2xl text-[#2196F3]"></i>
                </div>
                <div>
                  <h5 className="font-semibold text-[#0A2647] mb-1">Personalized Service</h5>
                  <p className="text-gray-600 text-sm">Tailored solutions for your unique needs</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#2196F3]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-2xl text-[#2196F3]"></i>
                </div>
                <div>
                  <h5 className="font-semibold text-[#0A2647] mb-1">Trusted Expertise</h5>
                  <p className="text-gray-600 text-sm">Licensed professionals you can rely on</p>
                </div>
              </div>
            </div>

            <a
              href="tel:512-306-6245"
              className="inline-flex items-center gap-2 bg-[#0A2647] hover:bg-[#0A2647]/90 text-white px-6 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill"></i>
              Schedule a Consultation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
